import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const DocTypeService = {
  getAllDocTypesByPagination(obj) {
    return httpClient.post(endPoints.getAllDocTypesByPagination, obj);
  },
  getDocTypeDetailByDocTypeCode(obj) {
    return httpClient.post(endPoints.getDocTypeDetailByDocTypeCode, obj);
  },
  addDocType(obj) {
    return httpClient.post(endPoints.addDocType, obj);
  },
  updateDocType(obj) {
    return httpClient.post(endPoints.updateDocType, obj);
  },
  deleteDocType(obj) {
    return httpClient.post(endPoints.deleteDocType, obj);
  },
};

export default DocTypeService;



// WEBPACK FOOTER //
// ./src/service/DocTypeService.js